/**
 * Calculate sum of array elements using a reducer
 * @param prop
 * @returns {function(number, any): number}
 */
export const baseSumReducer =
    (prop?: string) =>
    (total: number | undefined, value: any): number => {
        if (typeof total !== 'number') {
            total = 0;
        }

        if (prop && value && typeof value === 'object') {
            value = value[prop];
        }

        return total + (value || 0);
    };
